import mustache from 'mustache'
import { User } from '@/app/definitions/User'
import { hasPrivilege } from '@/app/user/whoAmI'
import { TedsUIOptionsWithFeatureFlags } from '@/boot'
import { HttpSettingsLauncherLink, LinkTemplateData, LauncherLink } from './LauncherLinks'

/**
 * Creates a function that will transform the "http-settings version of a launcher link"
 * to a bonafide LauncherLink
 * @param data
 * @returns
 */
export const createLinkTransformer =
  (data: LinkTemplateData) =>
  (settingsLink: HttpSettingsLauncherLink): LauncherLink => {
    const { description, hrefTemplate, logoComponent, rules, textLabel } = settingsLink
    return {
      description,
      logoComponent,
      rules,
      textLabel,
      href: mustache.render(hrefTemplate, data),
    }
  }

/** Determines whether user should be shown a given Launcher Tile */
export const userSatisfiesLauncherLinkRules =
  (options: TedsUIOptionsWithFeatureFlags) =>
  (user: User) =>
  (rules: LauncherLink['rules']): boolean => {
    /** If public then override any other rules */
    if (rules.public) return true
    /** If should be admin and not then return false */
    if (rules.access.isAdmin === true && user.isAdministrator !== true) return false
    /** If needed feature not enable then return false */
    if (rules.access.featureFlag) {
      const isFeatureOnForUser = options.featureFlags[rules.access.featureFlag]
      if (!isFeatureOnForUser) return false
    }
    /** If privileges are needed check that user has at least one */
    if (rules.access.privilege && rules.access.privilege.length) {
      const hasProperPrivilege = rules.access.privilege.some(privilege => hasPrivilege(privilege)(user))
      if (!hasProperPrivilege) return false
    }
    return true
  }
